export const UPDATE_URL = "UPDATE_URL";
export const RESET_URL = "RESET_URL";
